export const REQUESTED_MISSIONS = 'REQUESTED_MISSIONS';
export const RECEIVED_MISSIONS = 'RECEIVED_MISSIONS';
export const ERROR_MISSIONS = 'ERROR_MISSIONS';
export const REQUESTED_UPDATE_MISSION = 'REQUESTED_UPDATE_MISSION';
export const RECEIVED_UPDATE_MISSION = 'RECEIVED_UPDATE_MISSION';
export const ERROR_UPDATE_MISSION = 'ERROR_UPDATE_MISSION';
export const requestedMissions = () => ({
  type: REQUESTED_MISSIONS
});

export const receivedMissions = (missions) => ({
  type: RECEIVED_MISSIONS,
  missions
});

export const errorMissions = (error) => ({
  type: ERROR_MISSIONS,
  error
});

export const requestedUpdateMission = (payload) => ({
  type: REQUESTED_UPDATE_MISSION,
  updatePayload: payload
});

export const receivedUpdateMission = (result) => ({
  type: RECEIVED_UPDATE_MISSION,
  result
});

export const errorUpdatingMission = (error) => ({
  type: ERROR_UPDATE_MISSION,
  error
});

export const FILTER_MISSION = 'FILTER_MISSION';

export const filterMission = (missionToRemove) => ({
  type: RECEIVED_MISSIONS,
  mission: missionToRemove
});

export const UPDATED_FUNDING_METHOD = 'UPDATED_FUNDING_METHOD';
export const receivedFundingMethod = (fundingMethod) => ({
  type: UPDATED_FUNDING_METHOD,
  fundingMethod
});

export const UPDATE_STEP_MODAL_ACTION = 'UPDATE_STEP_MODAL_ACTION';
export const setStepModalAction = (action) => ({
  type: UPDATE_STEP_MODAL_ACTION,
  action
});

export const UPDATE_STEP_MODAL_AGREEMENT = 'UPDATE_STEP_MODAL_AGREEMENT';
export const setStepModalAgreementID = (agreementID) => ({
  type: UPDATE_STEP_MODAL_AGREEMENT,
  agreementID
});

export const TOGGLE_STEP_MODAL_OPEN = 'TOGGLE_STEP_MODAL_OPEN';

export const STEP_MODAL_OPEN = 'STEP_MODAL_OPEN';
export const STEP_MODAL_CLOSE = 'STEP_MODAL_CLOSE';
export const RESET_FUNDING_METHOD = 'RESET_FUNDING_METHOD';
export const RESET_STEP_MODAL = 'RESET_STEP_MODAL';

export const toggleStepModal = () => ({
  type: TOGGLE_STEP_MODAL_OPEN
});

export const setStepModalOpen = () => ({
  type: STEP_MODAL_OPEN
});

export const setStepModalClose = () => ({
  type: STEP_MODAL_CLOSE
});
export const resetStepModal = () => ({
  type: RESET_STEP_MODAL
});

export const DECREMENT_STEP_MODAL = 'DECREMENT_STEP_MODAL';
export const decrementStep = () => ({
  type: DECREMENT_STEP_MODAL
});

export const INCREMENT_STEP_MODAL = 'INCREMENT_STEP_MODAL';
export const incrementStep = () => ({
  type: INCREMENT_STEP_MODAL
});

export const resetFundingMethod = () => ({
  type: RESET_FUNDING_METHOD,
})